export default __webpack_public_path__ + "static/mobile_landing-xmas-00da58e95a10d1ce3458cd429bd5b72f.png";